export default __webpack_public_path__ + "static/media/slider-left.0f717d0c.svg";